import { render } from "./AboutUs.vue?vue&type=template&id=2a1485a2&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs_Enhanced.css?vue&type=style&index=0&id=2a1485a2&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1485a2"]])

export default __exports__